// src/components/NavBar.tsx
import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Box,
  Button,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { Link as RouterLink } from 'react-router-dom';
import logo from '../../CSES_LOGO.png';

const NavBar = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const navItems = [
    { text: 'FAQs', link: '#faq' },
    { text: 'Sponsor Us', link: '#sponsor' },
  ];

  const mobileNavItems = [
    { text: 'FAQs', link: '#faq' },
    { text: 'Sponsor Us', link: '#sponsor' },
    { text: 'Apply Now', link: 'https://docs.google.com/forms/d/e/1FAIpQLSctCxMZNCU4CdCIn2Q_rGanRGCHsMi0QK8BwUG9oVTKCuYJmQ/viewform?usp=send_form' }, // external URL
  ];

  return (
    <>
      <AppBar
        position="sticky"
        elevation={0}
        sx={{
          backgroundColor: '#030E5D',
          borderBottom: '4px solid',
          borderImage: 'linear-gradient(to right, #725DEF, #63CDDB, #EBB211) 1',
          paddingY: '10px',
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          {/* Logo */}
          <Box>
            <RouterLink to="/">
              <img
                src={logo}
                alt="CSE Society Logo"
                style={{ height: '55px', cursor: 'pointer' }}
              />
            </RouterLink>
          </Box>

          {/* Desktop Nav */}
          <Box display={{ xs: 'none', md: 'flex' }} alignItems="center" gap={3}>
            {navItems.map(({ text, link }) =>
              link.startsWith('#') ? (
                <Button
                  key={text}
                  href={link}
                  sx={{
                    color: 'white',
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '1.1rem',
                    paddingX: 3,
                    paddingY: 1.5,
                    minHeight: '40px',
                  }}
                >
                  {text}
                </Button>
              ) : (
                <Button
                  key={text}
                  component={RouterLink}
                  to={link}
                  sx={{
                    color: 'white',
                    textTransform: 'none',
                    fontWeight: 600,
                    fontSize: '1.1rem',
                    paddingX: 3,
                    paddingY: 1.5,
                    minHeight: '40px',
                  }}
                >
                  {text}
                </Button>
              )
            )}

            {/* Special Interest Form button with gradient */}
            <Box
              component="a"
              href='https://docs.google.com/forms/d/e/1FAIpQLSctCxMZNCU4CdCIn2Q_rGanRGCHsMi0QK8BwUG9oVTKCuYJmQ/viewform?usp=send_form' // replace with your real form URL
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                textDecoration: 'none',
                background: 'linear-gradient(to left, #725DEF, #63CDDB, #EBB211)',
                padding: '3px',
                borderRadius: '999px',
              }}
            >
              <Box
                sx={{
                  backgroundColor: '#030E5D',
                  borderRadius: '999px',
                  padding: '10px 24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Typography
                  sx={{
                    color: 'white',
                    fontWeight: 700,
                    fontSize: '1rem',
                  }}
                >
                  Apply Now
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* Mobile Menu Icon */}
          <Box display={{ xs: 'block', md: 'none' }}>
            <IconButton color="inherit" onClick={() => setIsDrawerOpen(true)}>
              <MenuIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="top"
        open={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
        disableAutoFocus
        disableEnforceFocus
        disableRestoreFocus
      >
        <Box
          sx={{
            backgroundColor: '#030E5D',
            height: '250px',
            paddingTop: '20px',
          }}
        >
          <Box sx={{ textAlign: 'right', paddingRight: '20px' }}>
            <IconButton onClick={() => setIsDrawerOpen(false)} sx={{ color: 'white' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <List>
            {mobileNavItems.map(({ text, link }) => (
              <ListItem
                key={text}
                component="a"
                href={link}
                target={link.startsWith('http') ? '_blank' : undefined} // open external in new tab
                rel={link.startsWith('http') ? 'noopener noreferrer' : undefined}
                onClick={() => setIsDrawerOpen(false)}
                sx={{ cursor: 'pointer' }}
              >
                <ListItemText
                  primary={
                    <Typography
                      align="center"
                      sx={{
                        color: 'white',
                        fontSize: '1.2rem',
                        fontWeight: 600,
                      }}
                    >
                      {text}
                    </Typography>
                  }
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </Drawer>
    </>
  );
};

export default NavBar;
